/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Convert to Phi objects</h4>

<p>Convert a reference face into an editable Phi surface. Click on this icon, then on the face(s) you want to convert, then again on this icon.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('734781041')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<p>Holding the Shift key down will create a closed 0-thickness body. </p>`;

export default function ConvertPartstudioTooltip() {
    return h('div', { innerHTML: body });
}
